import { render, staticRenderFns } from "./date-question.vue?vue&type=template&id=62bb25fa&scoped=true"
import script from "./date-question.vue?vue&type=script&lang=js"
export * from "./date-question.vue?vue&type=script&lang=js"
import style0 from "./date-question.vue?vue&type=style&index=0&id=62bb25fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb25fa",
  null
  
)

export default component.exports